import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-nec-ac-line-schematic',
  standalone: false,
  templateUrl: './nec-ac-line-schematic.component.html',
  styleUrl: './nec-ac-line-schematic.component.scss'
})
export class NecAcLineSchematicComponent {
  @Input() acLineId: number | null = null;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
